export { default as LifestylesStylesFilterBadge } from './LifestylesStylesFilterBadge';
